export const ROLE_ERROR = {
    DELETE_SINGLE_USER_ROLE: 'DELETE_SINGLE_USER_ROLE'
};